module.exports = __webpack_public_path__ + "img/d010_3.c5671e60.png";